module.exports = __webpack_public_path__ + "static/media/A7v6.473fe249.mp3";